import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../../config/firebaseConfig';
import styles from './VisitsModal.module.css';
import AddVisitModal from './AddVisitModal';
import { FaCalendarAlt, FaPlus } from 'react-icons/fa';
import { toast } from 'react-toastify';

const VisitsModal = ({ project, onClose }) => {
  const [visits, setVisits] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchVisits = async () => {
    setLoading(true);
    try {
      const visitsQuery = query(
        collection(db, 'Visits'),
        where('projectId', '==', project.id)
      );
      const querySnapshot = await getDocs(visitsQuery);
      
      // Fetch employee details for each visit
      const visitsData = await Promise.all(querySnapshot.docs.map(async (visitDoc) => {
        const visitData = visitDoc.data();
        let employeeFullName = 'N/A';
        
        if (visitData.employeeId) {
          const employeeDoc = await getDoc(doc(db, 'Employees', visitData.employeeId));
          if (employeeDoc.exists()) {
            const employeeData = employeeDoc.data();
            employeeFullName = `${employeeData.eName} ${employeeData.eSurname}`;
          }
        }

        return {
          id: visitDoc.id,
          ...visitData,
          employeeFullName
        };
      }));

      setVisits(visitsData);
    } catch (error) {
      console.error('Error fetching visits:', error);
      toast.error('Ziyaret bilgileri yüklenirken hata oluştu!');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVisits();
  }, [project.id]);

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>
            <FaCalendarAlt className={styles.modalIcon} />
            Ziyaret Bilgileri
          </h2>
        </div>

        <div className={styles.modalContent}>
          <div className={styles.headerActions}>
            <button
              className={styles.addButton}
              onClick={() => setShowAddModal(true)}
            >
              <FaPlus className={styles.buttonIcon} /> Yeni Ziyaret Ekle
            </button>
          </div>

          <div className={styles.tableContainer}>
            {loading ? (
              <div className={styles.loadingIndicator}>
                <div className={styles.loadingSpinner}></div>
                <p>Ziyaretler yükleniyor...</p>
              </div>
            ) : visits.length > 0 ? (
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th>Çalışan</th>
                    <th>İlk Ziyaret Tarihi</th>
                    <th>Periyot</th>
                  </tr>
                </thead>
                <tbody>
                  {visits.map(visit => (
                    <tr key={visit.id}>
                      <td>{visit.employeeFullName}</td>
                      <td>{visit.firstVisitDate}</td>
                      <td>{visit.period}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className={styles.noData}>
                <FaCalendarAlt className={styles.noDataIcon} />
                <p>Bu projeye ait ziyaret kaydı bulunamadı.</p>
              </div>
            )}
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button className={styles.cancelButton} onClick={onClose}>
            Kapat
          </button>
        </div>

        {showAddModal && (
          <AddVisitModal
            project={project}
            onClose={() => setShowAddModal(false)}
            onVisitAdded={fetchVisits}
          />
        )}
      </div>
    </div>
  );
};

export default VisitsModal;